<ion-content>
  <div class="flex-container">
    <div class="left-column header-row">
      <div class="ion-text-start header-title">
        {{ title | translate}}
      </div>
    </div>
    <div class="right-column">
      <img class="close-icon" alt="" tooltip="{{'Close'  | translate }}" placement="bottom" (click)="closeModal()" src="assets/icon/cancel.svg">
    </div>
  </div>
  <div class="main-content">
    <ion-row>
      <ion-col>
        <ion-label class="cc-label"> {{'Language' | translate }} *</ion-label>
        <ng-select placeholder="{{'Select_Language' | translate }}" [virtualScroll]='true' [(ngModel)]="selectedLang"
          [items]="availableLngs" bindLabel="title" bindValue="val" [clearable]="true"
          (focusin)="ensureClearIconFocusable()" (keydown)="onLanguageSelectKeydown($event)">
        </ng-select>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-label class="cc-label"> {{'Name' | translate }} *</ion-label>
        <div class="file-input">
          <ion-input [(ngModel)]="name" placeholder="{{'Enter Name'| translate }}" class="input-label"></ion-input>
        </div>
      </ion-col>
    </ion-row>
    <div class="save-button">
      <ion-button [disabled]="!selectedLang || !name.trim()" class="app-btn" shape="round" fill="outline" color="primary" (click)="submit()">
        {{'Save'|translate}}
      </ion-button>
      <ion-button class="app-btn margin-right-16" shape="round" fill="outline" color="primary" (click)="cancel()">
        {{'Cancel'|translate}}
      </ion-button>
    </div>
  </div>
</ion-content>
